import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { push } from 'connected-react-router';
import { notification } from 'antd';

export const editStore: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { storeApi },
) =>
  action$.pipe(
    ofType(actions.EDIT_STORE_ACTIONS.REQUESTED),
    switchMap(({ payload: { store, file } }) =>
      storeApi.editStore(store).pipe(
        switchMap(({ store: { id } }) => {
          if (file) {
            return storeApi.uploadPhoto(id, file).pipe(
              switchMap(() =>
                of(actions.editStoreSucceeded(), push('/stores')),
              ),
              catchError(error => {
                return of(push('/stores'));
              }),
            );
          }

          return of(actions.editStoreSucceeded(), push('/stores'));
        }),
        catchError(error => {
          notification.error({
            message: error.response.message,
          });
          console.error('error edit', error);
          return of(actions.editStoreFailed(error.message.toString()));
        }),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/EditStore/services/epics/editStore.ts